import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';
import * as DetectionActions from '../../actions/Detection.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

const style = {
  wrap: {
    display: 'none',
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, .38)',
  },
  shown: {
    display: 'block',
  },
  container: {
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    overflow: 'auto',
  },
  form: {
    width: 585,
    height: 299,
    backgroundColor: 'white',
    position: 'relative',
    overflow: 'auto',
    marginBottom: 90,
    marginTop: 90,
    borderRadius: 10,
    '@media (max-width: 767px)': {
      width: '100%',
      margin: '90px 10px',
    },
  },
  controller: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px 42px 0 24px',
    margin: '16px 0 12px 0',
  },
  controlBtn: {
    color: '#FBBB0C',
    fontSize: 60,
    width: 60,
    backgroundColor: 'transparent',
    border: 0,
    outline: 'none',
    padding: 0,
    margin: '0 38px',
    opacity: 0.75,
  },
  progressBar: {
    display: 'flex',
    position: 'relative',
    width: 300,
    height: 32,
    padding: '15px 0',
    backgroundColor: '#9B9B9B',
    borderRadius: 1,
    backgroundClip: 'content-box',
    '@media (max-width: 767px)': {
      width: '100%',
    },
  },
  progressPan: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'block',
    borderRadius: 16,
    width: 32,
    height: 32,
    outline: 'none',
    backgroundColor: 'white',
    border: '1px solid #9B9B9B',
  },
  progressPanTarget: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'block',
    borderRadius: 16,
    width: 32,
    height: 32,
    border: 0,
    outline: 'none',
    backgroundColor: '#FBBB0C',
    opacity: 0.3,
    zIndex: 10,
    pointerEvents: 'none',
  },
  contentWrap: {
    padding: '20px 40px',
    textAlign: 'center',
  },
  text: {
    display: 'block',
    lineHeight: 1.5,
    fontSize: 18,
  },
  bottomWrap: {
    width: '100%',
    textAlign: 'center',
    position: 'absolute',
    bottom: 0,
    lineHeight: '52px',
    padding: 0,
    textDecoration: 'none',
    color: 'white',
    borderTop: '1px solid #D8D8D8',
    letterSpacing: 1.5,
    fontSize: 24,
    backgroundColor: 'rgb(254, 211, 18)',
    borderLeft: 0,
    borderRight: 0,
    borderBottom: 0,
    cursor: 'pointer',
  },
};

class DetectionStartModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      playing: false,
      volume: 50,
      muted: false,
      panStartX: null,
      barUnit: 3,
      lastTime: 0,
    };
  }

  componentDidMount() {

  }

  mouseDown(panStartX) {
    const {
      muted,
    } = this.state;

    if (muted) {
      this.setState({
        panStartX,
        volume: 0,
        muted: false,
      });
    } else {
      this.setState({
        panStartX,
      });
    }
  }

  mouseMove(x) {
    const {
      volume,
      panStartX,
      barUnit,
    } = this.state;

    if (!panStartX) return;

    const {
      pan,
      bar,
    } = this.refs;

    const startX = panStartX - (barUnit * volume) - 16;
    const tempX = Math.min(Math.max(x - startX - 32, -16), 284);
    const tempVolume = (tempX + 16) / barUnit;

    let barStyle = `linear-gradient(to right, #fbbb0c 0, #fbbb0c ${tempVolume}%`;
    barStyle += `, transparent ${tempVolume}%, transparent 100%)`;

    bar.style.backgroundImage = barStyle;
    pan.style.left = `${tempX}px`;
  }

  mouseUp() {
    const {
      panStartX,
    } = this.state;

    if (!panStartX) return;

    const {
      pan,
    } = this.refs;

    const nowX = parseInt(pan.style.left.replace(/px$/, ''), 10);
    const volume = (nowX + 16) / 3;

    this.setState({
      panStartX: null,
      volume,
      muted: !volume,
    });
  }


  render() {
    const {
      isShown,
      closeModal,
    } = this.props;


    const {
      volume,
      muted,
      barUnit,
    } = this.state;

    const styles = _.cloneDeep(style);
    const actualVolume = muted ? 0 : volume;
    let barStyle = `linear-gradient(to right, #fbbb0c 0, #fbbb0c ${actualVolume}%`;
    barStyle += `, transparent ${actualVolume}%, transparent 100%)`;

    return (
      <div style={[styles.wrap, isShown && styles.shown]} onMouseUp={() => this.mouseUp()}>
        <div style={styles.container}>
          <div style={styles.form}>
            <div style={styles.controller}>
              <button type="button" style={styles.controlBtn} onClick={() => this.toggleMuteState()} key="mute">
                <span className={`fa ${muted ? 'fa-volume-off' : 'fa-volume-up'}`} />
              </button>
              <div
                ref="bar"
                onMouseMove={(e) => this.mouseMove(e.clientX)}
                style={[styles.progressBar, { backgroundImage: barStyle }]}>
                <button
                  type="button"
                  ref="pan"
                  style={[styles.progressPan, { left: 'calc(50% - 16px)' }]} />
              </div>
            </div>
            <div style={styles.contentWrap}>
              <span style={styles.text}>即將開始進行聽力評估，</span>
              <span style={styles.text}>建議配戴耳機進行測驗，</span>
              <span style={styles.text}>請先將音量調整至 50% 的位置。</span>
            </div>
            <button onClick={() => closeModal()} style={styles.bottomWrap}>開始聽力測驗</button>
          </div>
        </div>
      </div>
    );
  }
}

DetectionStartModal.propTypes = {
  isShown: T.bool,
  closeModal: T.func,
};

export default connect(
  state => ({
    isShown: state.Detection.isShownModal,
  }),
  dispatch => bindActionCreators(DetectionActions, dispatch),
)(radium(DetectionStartModal));



// WEBPACK FOOTER //
// ./containers/Detections/DetectionStartModal.js